export enum PractitionerServiceRelationType {
    consumer = 'serviceConsumer',
    provider = 'serviceProvider',
    reader = 'serviceReader',
    supervisor = 'serviceSupervisor',
}
